import { RatingStars } from '@/components/marketplace/RatingStars';

export const ProductRatingSummary = ({ summary }) => {
    if (!summary) return null;
    const total = summary.total || 0;
    const avg = summary.avg || 0;
    const dist = summary.distribution || { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

    return (
        <div className="rounded-2xl border bg-card p-5">
            <div className="flex flex-col md:flex-row gap-6">
                {/* Left: big avg */}
                <div className="md:w-56 text-center md:border-r md:pr-6">
                    <div className="text-5xl font-bold tabular-nums" data-testid="product-rating-avg">{avg.toFixed(1)}</div>
                    <RatingStars value={avg} size="lg" />
                    <div className="text-sm text-muted-foreground mt-1">{total} calificación(es)</div>
                </div>
                {/* Right: distribution bars */}
                <div className="flex-1 space-y-1.5">
                    {[5, 4, 3, 2, 1].map(n => {
                        const count = dist[n] || 0;
                        const pct = total ? (count / total) * 100 : 0;
                        return (
                            <div key={n} className="flex items-center gap-2 text-xs">
                                <span className="w-3 tabular-nums">{n}</span>
                                <span className="text-amber-500">★</span>
                                <div className="flex-1 h-2 rounded-full bg-neutral-200 overflow-hidden">
                                    <div className="h-full bg-red-600" style={{ width: `${pct}%` }} />
                                </div>
                                <span className="w-8 text-right tabular-nums text-muted-foreground">{count}</span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
